import React from "react";
import { CheckIcon } from "@aureskonnect/react-ui";
import { AvForm } from "availity-reactstrap-validation";
import { useTranslation } from "react-i18next";
import { IoMdStar } from "react-icons/io";
import { Card } from "reactstrap";
import classnames from "classnames";
import { useSelector } from "react-redux";

interface LanguageCardProps {
    item: {
        id: string;
        label: string;
        flag: string;
        active: boolean;
        isDefault: boolean;
    };
    onToggle: (id: string) => void;
    onSetDefault: (id: string) => void;
}

export const LanguageCardWrapper: React.FC<LanguageCardProps> = React.memo(
    ({ item, onToggle, onSetDefault }) => {
        const { t } = useTranslation();
        const mainColor = useSelector(
            (state: any) => state.global.entityDetails.mainColor
        );

        const handleCardClick = () => onToggle(item.id);

        const handleStarClick = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (item.active) onSetDefault(item.id);
        };

        return (
            <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{
                    gap: "10px",
                    width: "min-content",
                    borderBottom: "1px solid #707070",
                    opacity: item.active === false ? "40%" : "",
                    cursor: "pointer",
                }}
                onClick={handleCardClick}
            >
                <Card
                    style={{
                        borderBottom: item.active
                            ? `${mainColor} 10px solid`
                            : "1px solid rgba(0,0,0,.125)",
                        width: "270px",
                        height: "240px",
                        borderRadius: "20px",
                        position: "relative",
                    }}
                >
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "0.2fr 0.8fr 0.3fr",
                            height: "100%",
                            padding: "10px",
                        }}
                    >
                        <CheckIcon
                            className="mt-2 ml-2"
                            height={45}
                            width={45}
                            style={{
                                fill: item.active ? mainColor : "#BCBCBC",
                            }}
                        />
                        <div className="d-flex justify-content-center align-items-center mt-5">
                            <img
                                src={item.flag}
                                alt="flag"
                                style={{
                                    width: "80px",
                                    height: "80px",
                                }}
                            />
                        </div>
                        <div />
                    </div>

                    <div
                        style={{
                            height: "58px",
                        }}
                        className={classnames(
                            "d-flex justify-content-center align-items-center pb-2"
                        )}
                    >
                        <div
                            style={{
                                minHeight: "50px",
                                minWidth: "50px",
                                cursor: "pointer",
                            }}
                            className="d-flex justify-content-center shadow-sm align-items-center rounded border"
                            onClick={handleStarClick}
                        >
                            <IoMdStar
                                style={{
                                    width: "30px",
                                    height: "30px",
                                    fill: item.isDefault ? "gold" : "#00000029",
                                }}
                            />
                        </div>
                    </div>
                </Card>

                <AvForm
                    className="d-flex justify-content-center align-items-center"
                    style={{ gap: "5px" }}
                >
                    <span
                        style={{
                            fontSize: "20px",
                            color: "#000000",
                            margin: 0,
                        }}
                    >
                        {t(item.label)}
                    </span>
                </AvForm>
            </div>
        );
    }
);
